import React, {ReactElement} from 'react';
import {Element, Link as LinkScroll} from 'react-scroll';

import WorldIconSvg from 'svg/partners/world-icon.svg';
import PurseIconSvg from 'svg/partners/purse-icon.svg';
import VisaLogotypeGreenSvg from 'svg/pay-systems/visa-logotype-green.svg';
import MasterCardLogotypeGreenSvg from 'svg/pay-systems/mastercard-logotype-green.svg';
import PayPalLogotypeGreenSvg from 'svg/pay-systems/paypal-logotype-green.svg';
import QiwiLogotypeGreenSvg from 'svg/pay-systems/qiwi-logotype-green.svg';
import WeСhatPayLogotypeGreenSvg from 'svg/pay-systems/wechat-pay-logotype-green.svg';

const SectionSecond = (): ReactElement => <>
    <section className="ofelos-pay-section second">
        <div className="ofelos-pay-inner">
            <Element className="anchor-section" name="business"/>
            <div className="ofelos-pay-section-title">
                <h2>Who uses our solution</h2>
            </div>
            <div className="ofelos-pay-list-items partners">
                <div className="item">
                    <span className="item-icon">
                        <img src={WorldIconSvg}/>
                    </span>
                    <div className="description">
                        <p>You provide online B2C services worldwide or you’re a PSP</p>
                    </div>
                </div>
                <div className="item">
                    <span className="item-icon">
                        <img src={PurseIconSvg}/>
                    </span>
                    <div className="description">
                        <p>You’re looking for a convenient way to receive payments from end users and make payouts</p>
                    </div>
                </div>
                <div className="item">
                    <div className="list-icons">
                        <span className="icon">
                            <img src={VisaLogotypeGreenSvg} alt="Visa"/>
                        </span>
                        <span className="icon">
                            <img src={MasterCardLogotypeGreenSvg} alt="Mastercard"/>
                        </span>
                        <span className="icon">
                            <img src={QiwiLogotypeGreenSvg} alt="Qiwi"/>
                        </span>
                        <span className="icon">
                            <img src={WeСhatPayLogotypeGreenSvg} alt="Wechat"/>
                        </span>
                        <span className="icon">
                            <img src={PayPalLogotypeGreenSvg} alt="Paypal"/>
                        </span>
                    </div>
                    <div className="description">
                        <p>Your customers use the most common payment methods</p>
                    </div>
                </div>
            </div>
            <div className="ofelos-pay-more">
                <LinkScroll
                    smooth={true}
                    duration={600}
                    to="contact"
                    className="button-general"
                >
                    Contact us
                </LinkScroll>
            </div>
        </div>
        <span className="star-element"></span>
    </section>
</>;

export default SectionSecond;
